export const configuration = {
    strapiURL: process.env.REACT_APP_STRAPI_URL,
    jwtToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OSwiaXNBZG1pbiI6dHJ1ZSwiaWF0IjoxNjE3ODYwMTUyLCJleHAiOjE2NDkzOTYxNTJ9.pFAVXOsrRaXl4FFsZH_CJ3W8OnSqyujLQhbF_evsAlQ"
}